// src/redux/reducers/confirmationDialogReducer.ts
import { SHOW_DIALOG, CLOSE_DIALOG, ConfirmationDialogPayload } from "../actions/confirmationDialogActions";

export interface ConfirmationDialogState extends ConfirmationDialogPayload {
  open: boolean;
}

const initialState: ConfirmationDialogState = {
  open: false,
};

const confirmationDialogReducer = (
  state: ConfirmationDialogState = initialState,
  action: any
): ConfirmationDialogState => {
  switch (action.type) {
    case SHOW_DIALOG:
      return { ...state, ...action.payload, open: true };
    case CLOSE_DIALOG:
      return { ...state, open: false };
    default:
      return state;
  }
};

export default confirmationDialogReducer;
